import * as yup from "yup";
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../context/AuthContext';

import { getUserProfile as getUserProfileApi } from '../../services/apiUserProfile'
import { useError } from "../../context/ErrorContext";


const schema = yup.object().shape({
  userName: yup.string(),
  firstName: yup.string(),
  lastName: yup.string(),
  userEmail: yup.string(),
  phoneNumber: yup.string().nullable(),
  countryCode: yup.string().nullable(),
  isProfileImageAvailable: yup.boolean(),
})


export function useUserProfile() {
  const { handleErrorAction } = useError();
  const { updateUserInfo, user } = useAuth();
  const isAuthenticated = user?.isAuthenticated || false
  const clientId = user?.clientId
  const { data, isLoading } = useQuery({
    queryKey: ["userData", clientId],
    queryFn: async () => {
      const { data } = await getUserProfileApi({ clientId })
      return await schema.validate(data);
    },
    onSuccess: (data) => {
      const isProfileImageAvailable = data.isProfileImageAvailable || false;
      updateUserInfo(isProfileImageAvailable);
    },
    enabled: isAuthenticated,
    onError: (error: Error) => {
      handleErrorAction(error)
    }
  });

  return { data, isLoading };
}